module.exports = new __parcel__URL__("project-settings-overview-app-skeleton.tpl.ae74a2f6.svg").toString();